/* sajin theme — theme.js */
'use strict';

// ── PAGE FADE TRANSITIONS ───────────────────────────────────────────────────
document.body.style.opacity = '1';

document.addEventListener('click', function(e) {
  var a = e.target.closest('a[href]');
  if (!a || a.target === '_blank') return;
  var href = a.getAttribute('href') || '';
  if (!href || href[0] === '#' || href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0) return;
  try { if (new URL(a.href).hostname !== location.hostname) return; } catch(err) { return; }
  if (a.href === location.href) return;
  e.preventDefault();
  var dest = a.href;
  document.body.style.opacity = '0';
  setTimeout(function() { location.href = dest; }, 300);
});

window.addEventListener('pageshow', function(e) {
  if (e.persisted) document.body.style.opacity = '1';
});

// ── TIMESTAMP (LA time) ─────────────────────────────────────────────────────
function updateTimestamp() {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Los_Angeles',
    month: '2-digit', day: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit', hour12: true
  }).formatToParts(new Date());
  const g = type => parts.find(p => p.type === type)?.value ?? '';
  const str = `${g('month')}/${g('day')}/${g('year')} ${g('hour')}:${g('minute')}${g('dayPeriod').toLowerCase()} LA`;
  document.querySelectorAll('#home-ts, #shop-ts, #pdp-ts, #page-ts').forEach(el => el && (el.textContent = str));
}
updateTimestamp();
setInterval(updateTimestamp, 15000);


// ── SCROLL CARET (shop page) ────────────────────────────────────────────────
const caret = document.getElementById('shop-caret');
if (caret) {
  window.addEventListener('scroll', () => {
    caret.classList.toggle('visible', window.scrollY > 60);
  }, { passive: true });
  caret.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
}


// ── MINI CART ────────────────────────────────────────────────────────────────
function updateMiniCart(cart) {
  const mini = document.getElementById('cart-mini');
  if (!mini) return;
  const countEl = document.getElementById('cm-count');
  const subEl   = document.getElementById('cm-sub-price');
  const n = cart.item_count;
  if (countEl) countEl.textContent = n + (n === 1 ? ' item in cart' : ' items in cart');
  if (subEl)   subEl.textContent   = formatMoney(cart.total_price);
  mini.classList.toggle('visible', n > 0);
}

function updateMobHeader(cart) {
  const wrap    = document.getElementById('mob-header-cart');
  const countEl = document.getElementById('mob-hc-count');
  if (!wrap) return;
  wrap.style.display = cart.item_count > 0 ? 'flex' : 'none';
  if (countEl) countEl.textContent = cart.item_count;
}

function formatMoney(cents) {
  const dollars = cents / 100;
  return '$' + (Number.isInteger(dollars) ? dollars : dollars.toFixed(2));
}


// ── PRODUCT DETAIL PAGE ─────────────────────────────────────────────────────
(function initPDP() {
  const mainImg   = document.getElementById('pdp-main-img');
  const sizeWrap  = document.getElementById('pdp-sizes');
  const variantId = document.getElementById('selected-variant-id');
  const atcBtn    = document.getElementById('pdp-atc');
  const priceEl   = document.getElementById('pdp-price');

// mobile swipe with slide animation
(function() {
  var swipeImg = document.getElementById('pdp-main-img');
  var swipeThumbs = Array.from(document.querySelectorAll('.pdp-thumb'));
  if (!swipeImg || swipeThumbs.length < 2) return;
  var swipeSrcs = swipeThumbs.map(function(t) { return t.dataset.src; });
  var swipeIdx = 0;
  var startX = 0;
  var isSwiping = false;
  var container = swipeImg.parentElement; // .pdp-main-img

  container.addEventListener('touchstart', function(e) {
    startX = e.changedTouches[0].screenX;
    isSwiping = true;
    swipeImg.style.transition = 'none';
  }, { passive: true });

  container.addEventListener('touchmove', function(e) {
    if (!isSwiping) return;
    var diff = e.changedTouches[0].screenX - startX;
    swipeImg.style.transform = 'translateX(' + diff + 'px)';
  }, { passive: true });

  container.addEventListener('touchend', function(e) {
    if (!isSwiping) return;
    isSwiping = false;
    var diff = startX - e.changedTouches[0].screenX;

    if (Math.abs(diff) < 50) {
      swipeImg.style.transition = 'transform 0.25s ease';
      swipeImg.style.transform = 'translateX(0)';
      return;
    }

    var dir = diff > 0 ? 1 : -1;
    var nextIdx = (swipeIdx + dir + swipeSrcs.length) % swipeSrcs.length;

    var nextImg = new Image();
    nextImg.src = swipeSrcs[nextIdx];
    nextImg.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;object-fit:contain;transform:translateX(' + (dir * 100) + '%);transition:transform 0.3s ease;';
    container.appendChild(nextImg);

    swipeImg.style.transition = 'transform 0.3s ease';
    swipeImg.style.transform = 'translateX(' + (-dir * 100) + '%)';
    setTimeout(function() { nextImg.style.transform = 'translateX(0)'; }, 10);

    setTimeout(function() {
      swipeImg.src = swipeSrcs[nextIdx];
      swipeImg.style.transition = 'none';
      swipeImg.style.transform = 'translateX(0)';
      if (container.contains(nextImg)) container.removeChild(nextImg);
      swipeIdx = nextIdx;
      swipeThumbs.forEach(function(t, i) { t.classList.toggle('active', i === swipeIdx); });
    }, 320);
  }, { passive: true });
})();

  // thumbnail swap
  document.querySelectorAll('.pdp-thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      if (mainImg) mainImg.src = thumb.dataset.src;
      document.querySelectorAll('.pdp-thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });

  // size selection
  if (sizeWrap) {
    sizeWrap.querySelectorAll('.size-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        if (btn.disabled) return;
        sizeWrap.querySelectorAll('.size-btn').forEach(b => b.classList.remove('sel'));
        btn.classList.add('sel');
        if (variantId) variantId.value = btn.dataset.variantId;
        if (priceEl && btn.dataset.variantPrice) priceEl.textContent = btn.dataset.variantPrice;
      });
    });
  }

  const mobSelect = document.getElementById('mob-size-select');
  const mobAtc    = document.getElementById('mob-atc');

  // mobile size select → sync variant id + price
  if (mobSelect) {
    mobSelect.addEventListener('change', () => {
      const opt = mobSelect.options[mobSelect.selectedIndex];
      if (variantId) variantId.value = opt.value;
      if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
      if (mobAtc) {
        mobAtc.disabled = opt.disabled;
        mobAtc.textContent = opt.disabled ? 'sold out' : 'add to bag';
      }
    });
  }

  const mobControls = document.querySelector('.mob-controls');
  const mobRemove   = document.getElementById('mob-remove');

  function setMobInCart(itemKey, cart) {
    if (mobControls) mobControls.classList.add('incart');
    updateMobHeader(cart);
    if (mobRemove) {
      mobRemove.onclick = function() {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: itemKey, quantity: 0 })
        })
        .then(r => r.json())
        .then(cart => {
          if (cart.item_count === 0) {
            window.location.href = '/collections/all';
            return;
          }
          if (mobControls) mobControls.classList.remove('incart');
          if (mobAtc) { mobAtc.disabled = false; mobAtc.textContent = 'add to bag'; }
          updateMiniCart(cart);
          updateMobHeader(cart);
        })
        .catch(console.error);
      };
    }
  }

  // shared add-to-cart logic
  function doAddToCart() {
    const id = variantId ? variantId.value : null;
    if (!id) { alert('please select a size.'); return; }
    const btns = [atcBtn].filter(Boolean);
    btns.forEach(b => { b.disabled = true; b.textContent = 'adding...'; });
    if (mobAtc) { mobAtc.disabled = true; mobAtc.textContent = 'adding...'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(id), quantity: 1 })
    })
    .then(r => r.json())
    .then(lineItem => {
      const itemKey = lineItem.key;
      btns.forEach(b => { b.textContent = 'added'; setTimeout(() => { b.disabled = false; b.textContent = 'add to bag'; }, 1500); });
      fetch('/cart.js').then(r => r.json()).then(cart => {
        updateMiniCart(cart);
        setMobInCart(itemKey, cart);
      });
    })
    .catch(err => {
      console.error('add to cart error:', err);
      btns.forEach(b => { b.disabled = false; b.textContent = 'add to bag'; });
      if (mobAtc) { mobAtc.disabled = false; mobAtc.textContent = 'add to bag'; }
      alert('something went wrong. please try again.');
    });
  }

  if (atcBtn) atcBtn.addEventListener('click', doAddToCart);
  if (mobAtc)  mobAtc.addEventListener('click', doAddToCart);
})();


// ── FAQ ACCORDION ────────────────────────────────────────────────────────────
document.querySelectorAll('.faq-q').forEach(qEl => {
  qEl.addEventListener('click', () => {
    const item = qEl.closest('.faq-item');
    const open = item.classList.toggle('open');
    const plus = qEl.querySelector('span:last-child');
    if (plus) plus.textContent = open ? '−' : '+';
  });
});


// ── MAILING LIST ─────────────────────────────────────────────────────────────
const mailingForm = document.querySelector('.mailing-form-js');
if (mailingForm) {
  mailingForm.addEventListener('submit', e => {
    e.preventDefault();
    const ok = document.getElementById('mail-ok');
    mailingForm.style.display = 'none';
    if (ok) ok.style.display = '';
  });
}
